module.exports = __webpack_public_path__ + "static/media/flathead_cat.3882934e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flathead_cat.png
// module id = 860
// module chunks = 0